<template>
    <div class="ocr-result" v-loading="loading" element-loading-text="识别结果加载中，请稍等">
        <template v-if="noData">
            <div class="noMsg">暂无识别结果</div>
        </template>
        <template v-else>
            <div class="search">
                <el-input placeholder="请输入内容搜索" prefix-icon="el-icon-search" v-model="inputOcr"
                    @change="searchChange"></el-input>
            </div>
            <div style="margin-bottom:60px">
                <div class="row" v-for="(item,index) in originData" ref="row" :key="index">
                    <div style="display: inline-block; width:3%;color: #484949;font-size: 14px;">
                        <p>{{index+1}}</p>
                    </div>
                    <div style="display: inline-block;width:90%">
                        <span class="filed" v-for="(x,i) in item" :key="i" :class="{last:i===item.length-1}"
                            @click="mapping(x,index,i)" ref="word" v-html="x._char"></span>
                    </div>
                </div>
            </div>
            <div class="buttonshib">
                <!-- <el-button size="small" type="test" class="jiucbun" @click="errorjiuzhneg()" style="text-align: center;padding: inherit;float: right;margin-right: 30px;width: 124px;height: 32px;">识别结果纠错</el-button>             -->
            </div>
        </template>
    </div>
</template>
<script>
    import {
        mapState,
        mapGetters,
        mapMutations,
        mapActions,
    } from 'vuex'

    import _ from 'lodash'
    import bus from '@/assets/js/bus'
    import busType from '@/assets/js/busType'

    export default {
        name: 'ocrResult',
        props: {},
        data() {
            return {
                inputOcr: '',
                responseData: [],
                originData: [],
                loading: false,
                noData: false,
                moverchar: '',
                coordinates: [],
                arrlist: [],
                changerouter: '',
                changequery: {},
            };
        },
        computed: {
            ...mapState(['labelState']),
            ...mapGetters(['editTemplate', 'editType', 'currentImage', 'ocrResults', 'tabOCRName', 'markCreate', 'editNode', 'imageItem', 'resitem', 'itemerror']),
        },
        components: {},
        watch: {
            ocrResults(val) {
                this.originData = _.cloneDeep(val)[0];
            },
            currentImage(val) {
                this.originData = _.cloneDeep(this.ocrResults)[val];
            },
            editTemplate: {
                handler(val) {
                    if (val === null) {
                        this.loading = true;
                    } else {
                        this.originData = _.cloneDeep(this.ocrResults)[0]
                        this.loading = false;
                    }
                },
                deep: true
            },
        },
        mounted() {
            this.changequery = this.$route.query
            this.changerouter = this.$route.name
            try {
                //是缓存数据用的
                localStorage.setItem('field', JSON.stringify({
                    changerouter: this.$route.name,
                }))
            } catch (e) { }
            this.originData = _.cloneDeep(this.ocrResults)[this.currentImage];
            bus.$emit(busType.STARTOCR);
        },
        methods: {
            //识别结果纠错按钮页面跳转
            errorjiuzhneg() {
                if (this.changerouter == 'classifyEdit') {
                    this.$router.push({
                        //  path: '/dashboard/template/testpage/erroreage',
                        path: '/dashboard/classify/editPageErrorvue',
                        query: {
                            id: this.changequery.id,
                            name: this.changequery.name,
                            ruleId: this.changequery.ruleId,
                            routerchange: this.changerouter,
                        }
                    })
                }
                else {
                    this.$router.push({
                        path: '/dashboard/template/erroreage',
                        query: {
                            id: this.changequery.id,
                            name: this.changequery.name,
                            ruleId: this.changequery.ruleId,
                            category: this.changequery.category,
                            routerchange: this.changerouter,
                            certiType: this.changequery.certiType,
                        }
                    })
                }
            },
            mapping(x, index, i) {
                // 点击右侧某个框，映射到图片上

                // 编辑类型是文档类型
                if (this.editType) {
                    return;
                }
                // console.log(x, i, item)
                this.transformRect(x);

                // 移除红色高亮
                this.removeClass();

                // 红色高亮
                this.$refs.row[index].getElementsByTagName('span')[i].classList.add('active');
            },
            removeClass() {
                this.$refs.word.forEach(item => {
                    item.classList.remove('active');
                })
            },
            transformRect(x) {
                let item = this.$utils.getOneRect(x)

                this.$polygon.setData([item]);
                this.$polygon.selected(item);
                // 定位
                this.$polygon.setPosition(item);
            },
            searchChange(searchWord) {
                //搜索高亮关键词
                this.originData.forEach(item => {
                    item.forEach(x => {
                        // 转换成大写，大小写都会搜索到
                        let value = x.words.toUpperCase().indexOf(searchWord.toUpperCase());
                        if (value > -1) {
                            // 截取单词前半部分
                            x._char = x.words.slice(0, value);

                            // 补充高亮部分
                            for (let ii = value; ii < value + searchWord.length; ii++) {
                                x._char += '<em>' + x.words.charAt(ii) + '</em>'
                            }

                            // 截取单词后半部分
                            let end = x.words.slice(value + searchWord.length, x.words.length);

                            x._char += end;
                        } else {
                            x._char = x.words;
                        }
                    })

                })
                //自动定位
                this.$nextTick(() => {
                    let ocrResult = document.querySelector('.ocr-result')
                    let em = ocrResult.getElementsByTagName('em');
                    if (em.length > 0) {
                        ocrResult.scrollTop = em[0].offsetTop - 100;
                    }
                })

            }
        }
    };
</script>
<style>
    .ocr-result {
        color: var(--color-d4);
        height: calc(100% - 108px);
        overflow-y: auto;
        padding: 20px 0 20px 20px;

        .noMsg {
            text-align: center;
            line-height: 20;
            color: #9e9e9e;
        }

        .search {
            margin-bottom: 20px;

            .el-input {
                width: 80%;
            }

            .jiucbun {
                text-align: center;
                padding: inherit;
                margin-left: 10px;
                padding: 0 10px;
                height: 30px;
                line-height: 30px;
            }
        }

        .el-input__inner {
            height: 36px;
            line-height: 36px;
        }

        .row {
            margin-bottom: 16px;

            span {
                display: inline-block;
                border: 1px solid #3D7FFF;
                padding: 5px 20px;
                font-size: 14px;
                /* height: 20px; */
                line-height: 20px;
                color: #3D7FFF;
                /* color: var(--color-d4); */
                margin-right: 20px;
                white-space: pre-wrap;
                border-radius: 4px;
            }

            span.last {
                margin-right: 0;
            }

            .filed {
                em {
                    background: #ffe200;
                }

                .ocrLabel {
                    width: 16px;
                    height: 16px;
                }

                .ocrLabel:hover {
                    color: #3D7FFF;
                    width: 16px;
                    height: 16px;
                }

                .el-input__suffix {
                    margin-right: 0px !important;

                    .el-input__suffix-inner {
                        margin-right: 0px !important;
                    }
                }
            }

        }

        .row {
            span.active {
                background: rgba(255, 86, 0, 0.1);
                border-radius: 4px;
                border: 1px solid #FF4300;
                color: #3D7FFF;
            }
        }

        .buttonshib {
            position: absolute;
            bottom: 24px;
            right: 24px;
            margin-bottom: 5px;
        }

        .el-icon-search:before {
            color: #667180;
        }
    }
</style>